import { Navigate, useLocation } from "react-router";
import { useAuth } from "@/contexts/AuthContext";
import LoginForm from "@/components/auth/LoginForm";
import SEO from "@/components/seo/SEO";

interface LocationState {
  from?: {
    pathname: string;
  };
}

export default function Login() {
  const { session, isLoading } = useAuth();
  const location = useLocation();
  const state = location.state as LocationState | null;
  const from = state?.from?.pathname || "/admin";

  if (isLoading) {
    return (
      <>
        <SEO title="Login" noindex />
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-lg text-gray-600">Loading...</div>
        </div>
      </>
    );
  }

  if (session) {
    return (
      <>
        <SEO title="Login" noindex />
        <Navigate to={from} replace />
      </>
    );
  }

  return (
    <>
      <SEO title="Login" noindex />
      <div className="min-h-screen flex items-center justify-center bg-gray-50 login-page">
        <style>{`
          .login-page input,
          .login-page label {
            color: #111827 !important;
          }
        `}</style>
        <div className="w-full max-w-md p-8 bg-white rounded-xl shadow-sm">
          <div className="mb-8 text-center">
            <h1 className="text-2xl font-semibold text-gray-900">
              Admin Login
            </h1>
            <p className="mt-2 text-sm text-gray-500">
              Sign in to access the admin dashboard
            </p>
          </div>
          <LoginForm />
        </div>
      </div>
    </>
  );
}
